import {createClient, type Interceptor} from '@connectrpc/connect';
import {createConnectTransport} from '@connectrpc/connect-web';

import {backendHost} from '../config';
import {HistoryService} from '../generated/historyapi/history_pb';
import {auth} from '../setup';

// Mirrors apollo.ts's authMiddleware headers.
const authInterceptor: Interceptor = next => async req => {
  const token = await auth.ensureCurrentIdToken();
  if (token) {
    req.header.set('authorization', `Bearer ${token}`);
  }
  req.header.set('X-Origin', window.location.origin);
  return next(req);
};

const transport = createConnectTransport({
  baseUrl: backendHost(),
  useBinaryFormat: true,
  defaultTimeoutMs: 60_000,
  // connect-web v2 has no `credentials` option; set it via the fetch override.
  fetch: (input, init) =>
    window.fetch(input, {...init, credentials: 'include'}),
  interceptors: [authInterceptor],
});

export const historyClient = createClient(HistoryService, transport);
